import { HeaderTemplate2Props } from "@made-people/blueprint-header";
import { MissMaryLogo } from "../../../assets/icons/MissMaryLogo";
import { CartIcon } from "../../../assets/icons/Cart";

export const HeaderTemplate2: HeaderTemplate2Props = {
  logo: {
    svg: <MissMaryLogo />,
  },
  accountTrigger: {
    enabled: true,
    href: "comfort-club",
  },
  cartTrigger: {
    type: "mini-cart",
    icon: {
      iconSvg: <CartIcon />,
    },
  },
  searchTrigger: {
    enabled: true,
  },
  menuTrigger: {
    enabled: false,
  },
};
